<template>
  <Modal @close="closeModalLocal" :wide="true" width="1300px" normal-width="90vw" set-class="no-padding-mobile">
    <div slot="header">
      <div class="modal-header">
        <div class="" v-if="unit">
        </div>
      </div>
    </div>
    <div :class="'modal-content active-tab-' + activeTab" v-if="unit && open">

      <Loading :show="loading" />

      <div class="h1" :class="{'has-subtitle': unit.subtitle}">
        <h1>
          {{(unit.display_name || unit.description_title)}}
          <i v-if="unit.subtitle">{{unit.subtitle}}</i>
        </h1>
      </div>

      <div class="multiple-accomodations" v-if="confirmedAccomodations.length && !editing">
        Du har redan ett boende i varukorgen. Om du vill boka flera boenden i samma bokning måste du välja samma datum (<span>{{ [confirmedAccomodations[0].period.date_arrival, confirmedAccomodations[0].period.date_departure] | dateRange('D MMMM', ' - ')}}</span>).
      </div>

      <div :class="{'calendar-periods': true}">

        <div class="calendar-header center">
          <div>
            <label class="calendar-helper-text min-desktop">
              <icon name="calendar-blue" :scale="2" /><br />
              Öppna kalendervy för:
            </label>
          </div>
          <div class="calendar-buttons">
            <OutlineButton :style="'order: ' + getButtonOrderFor('winter')" v-if="this.validStartDatesWinter.length" class="filter-bt" :label="getButtonLabelFor('winter')" :closeLabel="getButtonLabelFor('winter')" :class="{active: winterCalendarOpen}" icon="skiing" :iconscale="2.5" :status="winterCalendarOpen" @clicked="toggleWinterCalendar" />
            <OutlineButton :style="'order: ' + getButtonOrderFor('summer')" v-if="this.validStartDatesSummer.length" class="filter-bt" :label="getButtonLabelFor('summer')" :closeLabel="getButtonLabelFor('summer')" :class="{active: summerCalendarOpen}" icon="biking" :iconscale="2.5" :status="summerCalendarOpen" @clicked="toggleSummerCalendar" />
            <OutlineButton :style="'order: ' + getButtonOrderFor('next_winter')" v-if="this.validStartDatesNextWinter.length" class="filter-bt" :label="getButtonLabelFor('next_winter')" :closeLabel="getButtonLabelFor('next_winter')" :class="{active: nextWinterCalendarOpen}" icon="skiing" :iconscale="2.5" :status="nextWinterCalendarOpen" @clicked="toggleNextWinterCalendar" />
          </div>
        </div>

        <div :class="{calendar: true, opened: winterCalendarOpen}">

          <DatepickerRangeModal :params="{
              componentType:'ModalFaker',
              clickOutside: false,
              validDates: this.validStartDatesWinter,
              disabledDays: this.disabledDays,
              specialDays: this.specialDays,
              onPickStart: this.updateEndDate,
              pickedStartDate: null,
              pickedEndDate: null,
              terminology: 'Välj',
              onClose: this.onPicked,
              infoOnPicked: 'Välj slutdatum',
              info: 'Välj vilken dag du vill bo från',
              disableSingle: true,
              open: this.SITE_CONFIG.modules_open.accomodation.open,
              closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
              startMonth: this.startMonth('winter')
            }" />

          </div>

        <div :class="{calendar: true, opened: summerCalendarOpen}">

          <DatepickerRangeModal :params="{
              componentType:'ModalFaker',
              clickOutside: false,
              validDates: this.validStartDatesSummer,
              disabledDays: this.disabledDays,
              specialDays: this.specialDays,
              onPickStart: this.updateEndDate,
              pickedStartDate: null,
              pickedEndDate: null,
              terminology: 'Välj',
              onClose: this.onPicked,
              infoOnPicked: 'Välj slutdatum',
              info: 'Välj vilken dag du vill bo från',
              disableSingle: true,
              open: this.SITE_CONFIG.modules_open.accomodation.open,
              closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
              startMonth: this.startMonth('summer')
            }" />

          </div>

        <div :class="{calendar: true, opened: nextWinterCalendarOpen}">

          <DatepickerRangeModal :params="{
              componentType:'ModalFaker',
              clickOutside: false,
              validDates: this.validStartDatesNextWinter,
              disabledDays: this.disabledDays,
              specialDays: this.specialDays,
              onPickStart: this.updateEndDate,
              pickedStartDate: null,
              pickedEndDate: null,
              terminology: 'Välj',
              onClose: this.onPicked,
              infoOnPicked: 'Välj slutdatum',
              info: 'Välj vilken dag du vill bo från',
              disableSingle: true,
              open: this.SITE_CONFIG.modules_open.accomodation.open,
              closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
              startMonth: this.startMonth('next_winter')
            }" />

          </div>

      </div>

      <div class="max-tablet">

          <div class="tabs-header center">
            <label>Välj period</label>
          </div>
          <div class="tabs">

          <!-- <div :class="[
            'tab',
            activeTab === 'calendar' && 'active',
          ]" @click="setTab('calendar')">
            <div>Välj datum</div>
          </div> -->
          <div :class="[
            'tab',
            activeTab === 'special' && 'active',
          ]" @click="setTab('special')" v-if="unit.prices_special_length">
            <div>Populära perioder 2025/26</div>
          </div>
          <div :class="[
            'tab',
            activeTab === (index + 1) && 'active',
          ]" @click="setTab(index + 1)"
            v-for="(value, index) in meta_super_titles">
            <div>{{value}}</div>
          </div>
        </div>
      </div>

      <div class="special-periods" v-if="unit.prices_special_length">

        <div class="heading">
          Populära perioder 2025/2026
        </div>

        <table>
          <tr class="title-row week-title-row">
            <th>
              <b>&nbsp;</b>
            </th>
            <th>
              Datum
            </th>
            <th>
              Pris
            </th>
          </tr>
          <tr v-for="price in sortedSpecialPrices">
            <td>
              <b v-html="price.title"></b>
              <div class="smaller" v-if="price.notes">{{ price.notes }}</div>
            </td>
            <td v-html="price.days">
            </td>
            <td :class="{notvalid: validPeriod && (price.period && (price.period.date_arrival + '-' + price.period.date_departure) != validPeriod)}">
              <span
                :class="{
                  price: true,
                  selected: (cartAccomodationObject && cartAccomodationObject.period && (cartAccomodationObject.unitLid == unit.unit_lid && cartAccomodationObject.poolLid == unit.pool_lid) && cartAccomodationObject.period.period == price.period.period && cartAccomodationObject.period.week == price.period.week)
                  }"
                v-if="price.period.free"
                @click="chooseAccomodation({
                  pool_lid: unit.pool_lid,
                  unit_lid: unit.unit_lid,
                  period: price.period,
                  week: price.period.week,
                  name: (unit.display_name || unit.description_title),
                  capacity: unit.capacity,
                  price: price.period.price
                  })">
                {{price.period.price | currency}}
              </span>
              <span class="taken" v-if="!price.period.free">
                -
              </span>
            </td>
          </tr>
        </table>

      </div>

      <div :class="{'normal-periods': true, 'no-specials': !unit.prices_special_length}" v-if="unit.prices_length">

        <div class="heading">
          PRISÖVERSIKT VINTER 2025/2026
        </div>

        <table>
          <tr class="title-row">
            <th> </th>
            <th :class="'period-super-title'" v-for="(meta, index) in meta_super_titles" v-if="meta" :colspan="meta_super_titles_colspan[index]">
              {{meta}}
            </th>
          </tr>
          <tr class="title-row week-title-row">
            <th class="week-indicator">
              <b>Vecka</b>
            </th>
            <th :class="'week-day-title index-' + belongsToCol(index)" v-for="(period, index) in meta_periods">
              {{period.days}}
            </th>
          </tr>
          <tr v-for="(week, index) in unit.prices" v-if="index >= meta_weeks[0] && index <= meta_weeks[1]">
            <td class="week-indicator" style="position:relative;">
              <b>v.{{week.week}}</b>
              <popper trigger="click" :options="{placement: 'right'}">
                <div class="popper">
                  <div v-html="showDates(week.periods)"></div>
                </div>
                <span slot="reference">
                  Datum
                </span>
              </popper>
            </td>
            <td v-for="(period, key, index) in week.periods" :class="(validPeriod && (period && (period.date_arrival + '-' + period.date_departure) != validPeriod) ? 'notvalid' : '') + ' p index-' + belongsToCol(index)">
              <span
                :class="{
                  price: true,
                  selected: (cartAccomodationObject && cartAccomodationObject.period && (cartAccomodationObject.unitLid == unit.unit_lid && cartAccomodationObject.poolLid == unit.pool_lid) && cartAccomodationObject.period.period == period.period && cartAccomodationObject.period.week == period.week)
                }"
                v-if="period && period.free && !period.hide && !period.note"
                @click="chooseAccomodation({
                  pool_lid: unit.pool_lid,
                  unit_lid: unit.unit_lid,
                  period: period,
                  week: week.week,
                  name: (unit.display_name || unit.description_title),
                  capacity: unit.capacity,
                  price: period.price
                  })">
                {{period.price | currency}}
              </span>
              <span class="taken" v-if="period && !period.free && !period.hide && !period.note">
                -
              </span>
              <span class="price-note" v-if="period && period.note">
                *
              </span>
              <span class="taken" v-if="!period">
                -
              </span>
            </td>
          </tr>
        </table>

      </div>

      <div v-if="!unit.prices_length && !unit.prices_special_length && !unit.prices_summer_length">
        <br/>
        <p style="text-align:center;">Det går för tillfället inte att visa några priser eller lediga perioder för detta boende. Kom tillbaka snart eller ring gästservice på <a href="tel:054-13 26 00">054-13 26 00</a></p>
      </div>

      <!--<button @click="openModal(['UnitInfoModal', {unit}])">Boendeinformation</button>-->

      <div style="clear:both;margin-top:15px;margin-bottom:15px;">&nbsp;</div>

      <div class="info-transparent" v-if="notes">
        <div v-for="note in notes">
          <b>*</b> {{note}}
        </div>
      </div>

      <div class="info" v-if="(unit.tags || []).indexOf('SATURDAY_ACCOMMODATION') !== -1 && SITE_CONFIG.settings.SettingAccommodationPriceViewInfo" v-html="SITE_CONFIG.settings.SettingAccommodationPriceViewInfo"></div>

      <div class="info" v-if="SITE_CONFIG.accomodations.date_limit_text" v-html="SITE_CONFIG.accomodations.date_limit_text"></div>
      <div class="info" v-if="SITE_CONFIG.accomodations.date_picker_help.special_info1" v-html="SITE_CONFIG.accomodations.date_picker_help.special_info1"></div>
      <div class="info" v-if="SITE_CONFIG.accomodations.date_picker_help.closed_slopes" v-html="SITE_CONFIG.accomodations.date_picker_help.closed_slopes"></div>
      <!-- <div class="info" v-if="SITE_CONFIG.site === 'kungsberget'">Anläggningen är stängd måndag, tisdag och onsdag vecka 12 och 13.</div> -->
      <!--<p style="text-align:center;" v-if="!loaded">Tillgängligheten uppdaterades senast {{moment(meta_updated).fromNow()}}... De laddas nu om, var god vänta...</p>-->

    </div>
    <div v-if="!open">
      <div class="info">
        <p>{{closedMessage}}</p>
      </div>
    </div>
    <pre v-if="false">{{ unit }}</pre>
  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import Loading from '@/components/components/Loading';
import DatepickerRangeModal from '@/components/modals/DatepickerRangeModal';
import API from '@/classes/API';
import moment from 'moment';

import OutlineButton from '@/components/deprecated/OutlineButton';

import accomodationIndex from '@/mixins/accomodationIndex';

import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/css/vue-popper.css';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    popper: Popper,
    Loading,
    DatepickerRangeModal,
    OutlineButton,
  },
  mixins: [accomodationIndex],
  data() {
    return {
      unit: null,
      meta_periods: null,
      meta_special: null,
      meta_weeks: null,
      meta_super_titles: null,
      meta_super_titles_colspan: null,
      indexes: [],
      meta_updated: null,
      loaded: false,
      loading: false,
      firstPrice: {},
      cartAccomodationObject: {},
      activeTab: 1,
      validStartDatesSummer: [],
      validStartDatesWinter: [],
      validStartDatesNextWinter: [],
      disabledDays: [],
      specialDays: [],
      calendarOpen: false,
      winterCalendarOpen: false,
      summerCalendarOpen: false,
      nextWinterCalendarOpen: false,
    };
  },
  async mounted() {
    if (typeof this.$route.query.no === 'undefined' || this.$route.query.no === '') {
      const query = this.$route.query;
      query.no = this.currentRealAccomodationIndex;

      setTimeout(() => {
        this.$router.replace({
          name: this.$route.name,
          query,
        });
      }, 1);
    }

    const { data } = await API.get(`/dates/valid-start-dates?view=object&accomodation=${this.$route.params.slug}`);

    Object.entries(data).forEach((element) => {
      if (element[1].free === 1) {
        if (element[1].date_arrival >= this.SITE_CONFIG.season.winter.start
          && element[1].date_arrival <= this.SITE_CONFIG.season.winter.end) {
          this.validStartDatesWinter.push(element[1].date_arrival);
        }

        console.log('next winter active', !!this.SITE_CONFIG.next_season.winter.is_active);

        if (!!this.SITE_CONFIG.next_season.winter.is_active
          && element[1].date_arrival >= this.SITE_CONFIG.next_season.winter.start
          && element[1].date_arrival <= this.SITE_CONFIG.next_season.winter.end) {
          console.log('checking next winter');
          this.validStartDatesNextWinter.push(element[1].date_arrival);
        }

        if (element[1].date_arrival >= this.SITE_CONFIG.season.summer.start
          && element[1].date_arrival <= this.SITE_CONFIG.season.summer.end) {
          this.validStartDatesSummer.push(element[1].date_arrival);
        }
      } else {
        this.disabledDays.push(element[1].date_arrival);
      }
    });

    this.specialDays = this.SITE_CONFIG.season.summer.special;

    await this.loadPrices('null');
    this.loaded = true;
    // this.loadPrices('refresh');

    if (this.SITE_CONFIG.site === 'kungsberget') {
      this.activeTab = 2;
    }

    this.$nextTick(() => {
      if (this.confirmedAccomodations.length) {
        this.openModal(['SecondAccomodationModal', {
          unitPreview: this.unit,
        }]);
      } else if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
        this.openModal(['SecondAccomodationModal', {
          unitPreview: this.unit,
        }]);
      }
    });
  },
  computed: {
    closedMessage() {
      return this.SITE_CONFIG.modules_open.accomodation.closed_message || this.SITE_CONFIG.closed_message || 'Anläggningen är tyvärr stängd.';
    },
    open() {
      if (typeof this.SITE_CONFIG.modules_open.accomodation.open !== 'undefined') {
        return this.SITE_CONFIG.modules_open.accomodation.open;
      }
      return this.SITE_CONFIG.is_open;
    },
    ...mapGetters([
      'confirmedAccomodations',
      'cart',
    ]),
    editing() {
      return !isNaN(parseInt(this.$route.query.no, 10));
    },
    confirmedAccomodations() {
      return this.cart.accomodations.filter(a => a.confirmed);
    },
    validPeriod() {
      let index = this.$route.query.no;
      if (typeof index === 'undefined') {
        index = -1;
      }

      const confirmedAccomodations = this.cart.accomodations.filter((a, i) =>
        (a.confirmed && parseInt(index, 10) !== i));

      let validPeriod = '';
      if (confirmedAccomodations.length) {
        validPeriod = `${confirmedAccomodations[0].period.date_arrival}-${confirmedAccomodations[0].period.date_departure}`;
      }

      return validPeriod;
    },
    sortedSpecialPrices() {
      let specialPrices = null;
      const newArray = [];
      specialPrices = Object.assign({}, this.unit.prices_special);

      for (let i in specialPrices) { // eslint-disable-line
        if (specialPrices[i]) { // eslint-disable-line
          newArray.push(specialPrices[i]); // eslint-disable-line
        } // eslint-disable-line
      } // eslint-disable-line

      newArray.sort((a, b) => {
        if (!a.period) {
          return 0;
        }

        if (a.period.date_arrival < b.period.date_arrival) {
          return -1;
        }

        if (a.period.date_arrival > b.period.date_arrival) {
          return 1;
        }

        if (a.period.date_departure < b.period.date_departure) {
          return -1;
        }

        if (a.period.date_departure > b.period.date_departure) {
          return 1;
        }

        return 0;
      });

      return newArray;
    },
    notes() {
      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      }

      const notes = [];

      for (var i in this.unit.prices) { // eslint-disable-line
        for (var ii in this.unit.prices[i].periods) { // eslint-disable-line
          let note = this.unit.prices[i].periods[ii].note; // eslint-disable-line
          if (note) { // eslint-disable-line
            notes.push(note); // eslint-disable-line
          } // eslint-disable-line
        } // eslint-disable-line
      } // eslint-disable-line

      return notes.filter(onlyUnique);
    },
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    belongsToCol(index) {
      return this.indexes[index] + 1;
    },
    async loadPrices(type) {
      this.loading = true;
      let url = `/units/${this.$route.params.poolId}/${this.$route.params.unitId}/prices`;

      if (this.$route.params.slug) {
        url = `/units/${this.$route.params.slug}/prices`;
      }

      if (type === 'refresh') {
        url = `${url}/refresh`;
      } else {
        let urlInfo = `/units/${this.$route.params.poolId}/${this.$route.params.unitId}/info`;
        if (this.$route.params.slug) {
          urlInfo = `/units/${this.$route.params.slug}/info`;
        }
        const { data } = await API.get(urlInfo);
        this.unit = data;
      }
      const { data } = await API.get(url);

      this.unit = data.accomodations;
      this.meta_periods = data.meta_periods;
      this.meta_special = data.meta_special;
      this.meta_weeks = data.meta_weeks;
      this.meta_super_titles = data.meta_super_titles;
      this.meta_super_titles_colspan = data.meta_super_titles_colspan;
      this.meta_updated = data.meta_updated;
      const firstKey = Object.keys(this.unit.prices)[10];
      this.firstPrice = this.unit.prices[firstKey];

      if (this.$store.state.tempCartAccomodation && this.$store.state.tempCartAccomodation.type) {
        this.cartAccomodationObject = this.$store.state.tempCartAccomodation;
      } else {
        const currentAccomodationIndex = this.currentRealAccomodationIndex;
        if (currentAccomodationIndex > -1) {
          this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];
        }
      }

      this.indexes = [];
      let iterator = 0;
      this.meta_super_titles_colspan.forEach((v) => {
        let i = this.indexes.length;
        const end = this.indexes.length + parseInt(v, 10);
        while (i < end) {
          this.indexes.push(iterator);
          i += 1;
        }
        iterator += 1;
      });

      if (type === 'refresh') {
        this.loaded = true;
      }

      this.loading = false;

      window.trackViewItem({
        title: this.unit.description_title,
        lines: [{
          id: this.unit.unit_code || this.unit.name_corrected,
          title: this.unit.description_title,
          category: 'accomodation',
          category2: (this.unit && this.unit.pool) ? this.unit.pool.name : '',
          quantity: 1,
          price: this.unit.lowest_price,
        }],
      });
    },
    async updateEndDate(value) {
      const formatted = moment(value).format('YYYY-MM-DD');
      const { data } = await API.get(`/dates/valid-end-dates/${formatted}?view=object&accomodation=${this.$route.params.slug}`);

      const validEndDates = [];
      const inValidEndDates = [];
      Object.entries(data).forEach((element) => {
        if (element[1].free === 1) {
          validEndDates.push(element[1].date_departure);
        } else {
          inValidEndDates.push(element[1].date_departure);
        }
      });

      return {
        valid: validEndDates,
        invalid: inValidEndDates,
      };
    },
    async onPicked(a, b, c, d) {
      const $this = this;

      const start = moment(a);
      const end = moment(b);
      const diff = end.diff(start, 'days');
      let includesClosedDate = false;
      let i = 0;

      while (i <= diff) {
        const dateToCheck = start.clone().add((i), 'days').format('YYYY-MM-DD');
        console.log(dateToCheck);

        if (this.SITE_CONFIG.season.summer.special.indexOf(dateToCheck) === -1) {
          includesClosedDate = true;
        }

        i += 1;
      }

      // Todo: temporary during last days of summer season
      // includesClosedDate = false;

      if (d && includesClosedDate) {
        this.openModal(['SummerConfirmationModal', {
          startDate: a,
          endDate: b,
          click: () => {
            $this.doChangeEndDate(a, b);
          },
          cancel: () => {
            console.log('Closing');
          },
        }]);

        this.openModal(['GeneralModal', {}]);
      } else {
        this.doChangeEndDate(a, b);
      }
    },
    doChangeEndDate(a, b) {
      console.log('Period selected');
      console.log(a, b);

      let url = `/units/${this.unit.pool_lid}/${this.unit.unit_lid}/prices`;

      const start = moment(a).format('YYYY-MM-DD');
      const end = moment(b).format('YYYY-MM-DD');

      url = `${url}/${start}/${end}`;

      API.get(url).then((payload) => {
        let period = null;

        for (let i in payload.data.accomodations.prices) { // eslint-disable-line
          if (payload.data.accomodations.prices[i]) { // eslint-disable-line
            period = payload.data.accomodations.prices[i]; // eslint-disable-line
          } // eslint-disable-line
        } // eslint-disable-line

        for (let i in payload.data.accomodations.prices_summer) { // eslint-disable-line
          if (payload.data.accomodations.prices_summer[i]) { // eslint-disable-line
            period = payload.data.accomodations.prices_summer[i]; // eslint-disable-line
          } // eslint-disable-line
        } // eslint-disable-line

        for (let i in payload.data.accomodations.prices_extra) { // eslint-disable-line
          if (payload.data.accomodations.prices_extra[i]) { // eslint-disable-line
            period = payload.data.accomodations.prices_extra[i].period; // eslint-disable-line
          } // eslint-disable-line
        } // eslint-disable-line

        for (let i in payload.data.accomodations.prices_special) { // eslint-disable-line
          if (payload.data.accomodations.prices_special[i]) { // eslint-disable-line
            period = payload.data.accomodations.prices_special[i].period; // eslint-disable-line
          } // eslint-disable-line
        } // eslint-disable-line

        if (!period) {
          return false;
        }

        this.chooseAccomodation({
          pool_lid: this.unit.pool_lid,
          unit_lid: this.unit.unit_lid,
          period,
          week: period.week,
          name: (this.unit.display_name || this.unit.description_title),
          capacity: this.unit.capacity,
          price: period.price,
        });

        return true;
      });
    },
    moment(d) {
      return moment(d);
    },
    closeModalLocal() {
      if (this.$route.query.flow) {
        if (this.$route.query.flow.substr(0, 12) === 'boenden/info') {
          this.$router.push({ path: `/${this.$route.query.flow}?flow=boenden&no=${this.$route.query.no}` });
        } else {
          this.$router.push({ path: `/${this.$route.query.flow}?no=${this.$route.query.no}` });
        }
      } else {
        this.$router.push({ path: `/boenden?no=${this.$route.query.no}` });
      }
    },
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
    ]),
    didChooseAccomodation(payload) {
      let no = this.currentRealAccomodationIndex;
      const p = payload;

      p.unit = this.unit;
      p.no = parseInt(this.$route.query.no, 10);

      if (p.no === -1) {
        no = this.$store.state.cart.accomodations.filter(a => a.confirmed).length;
      } else {
        no = p.no;
      }

      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;

      this.pickAccomodation(p);
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      const url = this.$route.path.substr(1);

      if (this.$route.query.flow === 'boenden') {
        const arrival = moment(payload.period.date_arrival).format('YYYY-MM-DD');
        const departure = moment(payload.period.date_departure).format('YYYY-MM-DD');
        this.$router.push({ path: `/boenden/info/${this.unit.slug}/${arrival}/${departure}?flow=${url}`, query: { no } });
      } else {
        this.$router.push({ name: 'confirm-accomodation', query: { no } });
      }
    },
    chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    showDates(periods) {
      let lines = [];
      lines = [];
      this.meta_periods.forEach((period) => {
        if (periods[`_${period.period_dbid}`].date_arrival && periods[`_${period.period_dbid}`].date_departure) {
          const arrival = moment(periods[`_${period.period_dbid}`].date_arrival).format('D/M');
          const departure = moment(periods[`_${period.period_dbid}`].date_departure).format('D/M');
          if (!periods[`_${period.period_dbid}`].hide) {
            lines.push(`<b>${period.days}:</b> ${arrival} - ${departure}`);
          }
        }
      });

      return lines.join('<br>');
    },
    toggleCalendar() {
      this.calendarOpen = !this.calendarOpen;
    },
    toggleWinterCalendar() {
      this.winterCalendarOpen = !this.winterCalendarOpen;
      if (this.winterCalendarOpen) {
        this.summerCalendarOpen = false;
        this.nextWinterCalendarOpen = false;
      }
    },
    toggleSummerCalendar() {
      this.summerCalendarOpen = !this.summerCalendarOpen;
      if (this.summerCalendarOpen) {
        this.winterCalendarOpen = false;
        this.nextWinterCalendarOpen = false;
      }
    },
    toggleNextWinterCalendar() {
      this.nextWinterCalendarOpen = !this.nextWinterCalendarOpen;
      console.log(this.nextWinterCalendarOpen);
      if (this.nextWinterCalendarOpen) {
        this.summerCalendarOpen = false;
        this.winterCalendarOpen = false;
      }
    },
    startMonth(season) {
      const now = moment().format('YYYY-MM-DD');
      let date = now;

      if (season === 'winter') {
        const length = this.validStartDatesWinter.length;
        date = length ? this.validStartDatesWinter[0] : now;
      } else if (season === 'next_winter') {
        const length = this.validStartDatesNextWinter.length;
        date = length ? this.validStartDatesNextWinter[0] : now;
      } else if (season === 'summer') {
        const length = this.validStartDatesSummer.length;
        date = length ? this.validStartDatesSummer[0] : now;
      }

      return Math.max(now, date);
    },
    getButtonOrderFor(season) {
      const firstWinter = this.validStartDatesWinter.length ? this.validStartDatesWinter[0] : '9999-10-31';
      const firstSummer = this.validStartDatesSummer.length ? this.validStartDatesSummer[0] : '9999-11-31';
      const firstNextWinter = this.validStartDatesNextWinter.length ? this.validStartDatesNextWinter[0] : '9999-12-31';

      let checkValue = '';

      if (season === 'winter') {
        checkValue = firstWinter;
      } else if (season === 'summer') {
        checkValue = firstSummer;
      } else if (season === 'next_winter') {
        checkValue = firstNextWinter;
      }

      const sorted = [firstWinter, firstSummer, firstNextWinter].sort();

      return sorted.indexOf(checkValue) + 1 || 0;
    },
    getButtonLabelFor(season) {
      let start = '';
      let end = '';
      let label = 'Datum';

      if (season === 'winter') {
        start = this.SITE_CONFIG.season.winter.start;
        end = this.SITE_CONFIG.season.winter.end;
        label = 'Vinter';
      } else if (season === 'summer') {
        start = this.SITE_CONFIG.season.summer.start;
        end = this.SITE_CONFIG.season.summer.end;
        label = 'Sommar';
      } else if (season === 'next_winter') {
        start = this.SITE_CONFIG.next_season.winter.start;
        end = this.SITE_CONFIG.next_season.winter.end;
        label = 'Vinter';
      }

      const yearStart = moment(start).format('YYYY');
      const yearEnd = moment(end).format('YYYY');

      if (yearStart === yearEnd) {
        return `${label} ${yearStart}`;
      }

      return `${label} ${yearStart}/${yearEnd}`;
    },
  },
  filters: {
    weekday(dt) {
      return moment(dt).format('ddd');
    },
    dt(dt) {
      return moment(dt).format('D[/]M');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.smaller
  font-size 85%
  margin-top 1px

.notvalid
  disabled()

.unavailable
  unavailable()

.modal-content
  position relative

.h1
  text-align center
  position absolute
  top -61px
  width 100%
  left: 0;
  +max-tablet()
    font-size: 18px!important
  &.has-subtitle
    top: -79px
  +max-tablet()
    top auto;
    left auto
    position: static
  h1
    united-heavy();
    font-size: 23px;
    text-align: center;
    color: #1c1c1c;
    margin 0 auto
    display inline-block
    background-color: #ffffff;
    border-radius: 5px 5px 0 0;
    padding 15px 28px 6px
    +max-tablet()
      font-size: 18px!important
      margin-bottom: 5px

    i
      font-style normal
      font-weight normal
      display block
      color greyish-brown
      margin-top 4px
      font-size 15px
      line-height 1em
      font-family Interstate
      letter-spacing 0em
      text-transform none

.info-transparent
  padding 15px 27px
  margin-top: 15px
  margin-right 0
  max-width 100%
  +max-tablet()
    margin-right 0

.special-periods
  float left
  width 35%
  margin-right 5%

.normal-periods
  float:left
  width:60%
  //margin-right 5%
  &.no-specials
    width 100%
    float none
    margin-right 0
&.calendar-periods
  margin-bottom: 25px

.title-row
  display: none
  &.week-title-row
    display: table-header-group;
  +min-xl-tablet()
    display: table-header-group;

table
  max-width 100%
  min-width 95%
  tr:nth-child(even)
    background-color #f9f9f9
  td,
  th
    padding 8px 12px
    text-align center
    white-space nowrap
    width 16%

    .price
      border-radius: 4px;
      background-color: greenish-light
      font-size: 13px;
      font-weight: bold;
      color: greenish;
      padding 4px 15px
      display inline-block
      text-align: center;
      cursor pointer
      transition-bt()
      min-width: 77px
      &:hover
        background-color: greenish
        color: greenish-light
    .selected
      background-color gold
      color white
      &:hover
        background-color: greenish
        color: greenish-light
    .taken
      border-radius: 2px;
      background-color: timeslot-taken;
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      color: #ffffff;
      padding 4px 15px
      display inline-block
      text-transform uppercase
    .price-note
      border-radius: 2px;
      font-weight: bold

.week-indicator
  b
    font-weight bold
    display inline-block
    width 30px
    text-align right
  span
    font-size: 11px;
    font-weight: 300;
    color: #005580;
    text-decoration underline
    cursor pointer
th.week-indicator
  b
    text-transform uppercase

th.period-super-title
  uppercase()

.week-day-title
  font-weight normal

.heading
  united-heavy()
  font-size: 20px;
  color: white;
  border-radius: 3px;
  background-color: var(--booking-color-primary);
  padding: 11px 17px 7px;
  width: 100%
  +max-tablet()
    display: none

.special-periods
  .heading
    background-color deep-sea-blue
    text-transform uppercase
  th, td
    text-align left

.popper
  border-radius 2px
  background-color #262626
  font-family Interstate
  font-size 12px
  font-weight 300
  color #ffffff
  padding 12px
  box-shadow none
  border 0
  text-align left

.tabs-header
  label
    margin-top: 12px;
    font-size: 12px;

.tabs
  display flex
  align-items stretch
  margin-bottom space-3
  margin-top 16px

  .tab
    background pale-sky
    flex 1 1 0
    border-right 1px solid alpha(deep-sea-blue, .2)
    font-size 12px
    padding space-1
    font-weight bold
    text-transform uppercase
    text-align center
    cursor pointer
    width 33%
    line-height: 1.2em;
    &:hover:not(.active)
      fill-shadow(light-blue-gray, .5)
      display inline-block
    &.active
      background deep-sea-blue
      color white
      position relative
      .icon
        color inherit
        &.icon-inactive
          display none
        &.icon-active
          display inline-block
      /*&:after
        color deep-sea-blue
        content ''
        display block
        position absolute
        bottom 0
        left 50%
        margin-left -10px
        margin-bottom -10px
        border-top 10px solid currentColor
        border-right 10px solid transparent
        border-bottom 0
        border-left 10px solid transparent*/
    &:first-child
      border-top-left-radius 3px
      border-bottom-left-radius 3px
    &:last-child
      border-top-right-radius 3px
      border-bottom-right-radius 3px
      border-right none

+max-tablet()
  table,
  .special-periods,
  .normal-periods,
  .calendar-periods
    width 100%
    float none
  .special-periods,
  .week-day-title,
  .normal-periods,
  .p
    display none
  .active-tab-special
    .special-periods
      display block
  .active-tab-calendar
    .calendar-periods
      display: block !important
      .calendar
        max-height: 1000px
  .active-tab-1
    .normal-periods
      display block
    .index-1
      display table-cell
  .active-tab-2
    .normal-periods
      display block
    .index-2
      display table-cell
  .active-tab-3
    .normal-periods
      display block
    .index-3
      display table-cell

.multiple-accomodations,
.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 15px
  margin-right 0
  max-width 100%
  +max-tablet()
    margin-right 0

.calendar
  max-height 0
  overflow hidden
  transition: all 0.2s
  &.opened
    max-height 1000px
label
  text-transform: uppercase;

.calendar-header
  margin-bottom: 8px
  .calendar-helper-text
    font-weight: 900
    font-size: 12px
    margin-bottom: 8px;
    .icon
      margin-bottom 8px

.calendar-buttons
  display: flex
  justify-content: center
  flex-wrap: wrap
  button
    margin-right: 4px
    margin-left: 4px
    margin-top: 4px
</style>



// WEBPACK FOOTER //
// AccomodationsPagePrice.vue?3b69693c